import type { PropsWithChildren } from 'react';
import classNames from 'classnames';
import { FilterGroup } from '@/components/filterGroup/FilterGroup';
import StarRatingFilter from './containers/starRatingFilter/StarRatingFilter';
import GuestRatingFilter from './containers/guestRatingFilter/GuestRatingFilter';
import HotelFacilityFilter from './containers/hotelFacilityFilter/HotelFacilityFilter';
import PriceFilter from './containers/priceFilter/PriceFilter';
import KeywordFilter from './containers/keywordFilter/KeywordFilter';
import PropertyTypeFilter from './containers/propertyTypeFilter/PropertyTypeFilter';
import HotelChainFilter from './containers/hotelChainFilter/HotelChainFilter';

interface Props {
    filtersOpen: boolean;
    className?: string;
}
export const SearchResultsFilters = ({ filtersOpen, children, className = '' }: PropsWithChildren<Props>) => (
    <div className={classNames('filters-overlay', className, { active: filtersOpen })} data-testid="filters-overlay">
        {children}
        <FilterGroup title="Type overnatting">
            <PropertyTypeFilter />
        </FilterGroup>
        <FilterGroup title="Hotellstandard">
            <StarRatingFilter />
        </FilterGroup>
        <FilterGroup title="Gjestevurderinger">
            <GuestRatingFilter />
        </FilterGroup>
        <FilterGroup title="Fasiliteter">
            <HotelFacilityFilter />
        </FilterGroup>
        <FilterGroup title="Totalpris">
            <PriceFilter />
        </FilterGroup>
        <FilterGroup title="Hotellnavnet inneholder">
            <KeywordFilter />
        </FilterGroup>
        <FilterGroup title="Hotellkjeder">
            <HotelChainFilter />
        </FilterGroup>
        <div className="u-hide-lt768 u-pv16 u-ph8 custom-expansion-panel">
            <a
                data-testid="SearchResults-feedback"
                href="mailto:kundesenter@finn.no?subject=Tilbakemelding hotellsøket"
                target="_blank"
                rel="noopener noreferrer">
                <h2 className="u-t4 u-licorice">Tips oss!</h2>
                <p>Vi setter pris på ditt innspill til forbedring av tjenesten.</p>
            </a>
        </div>
    </div>
);
